import { useTranslation as useI18nTranslation } from 'react-i18next';
import { NAMESPACES, Namespace } from '../i18n/namespaces';

/**
 * Custom hook that wraps react-i18next's useTranslation
 * with improved TypeScript support and namespace handling
 * 
 * @param ns - The namespace to use for translations (defaults to 'common')
 * @returns Translation utilities with proper TypeScript types
 */
export const useTranslation = (ns: Namespace = NAMESPACES.COMMON) => {
  const { t, i18n } = useI18nTranslation(ns);
  
  /**
   * Change the current language
   * @param lng - Language code to switch to
   */
  const changeLanguage = async (lng: string) => {
    await i18n.changeLanguage(lng);
  };
  
  /**
   * Get the current language
   * @returns Current language code
   */
  const getCurrentLanguage = () => {
    return i18n.language || 'en';
  };
  
  /**
   * Check if the current language is RTL
   * @returns True if the current language is RTL
   */
  const isRTL = () => {
    const rtlLanguages = ['ar', 'he', 'fa', 'ur'];
    return rtlLanguages.includes(getCurrentLanguage());
  };
  
  return {
    t,
    i18n,
    changeLanguage,
    getCurrentLanguage,
    isRTL,
  };
}; 